export const APPROVAL_WORKFLOW_ANALYTICS_EVENTS = {
  APPROVAL_WORKFLOW_CREATE: "approval-workflow-create",
  APPROVAL_WORKFLOW_UPDATE: "approval-workflow-update",
  APPROVAL_WORKFLOW_DELETE: "approval-workflow-delete",
  APPROVAL_WORKFLOW_STATUS_TOGGLE: "approval-workflow-status-toggle",
  APPROVAL_WORKFLOW_FETCH: "approval-workflow-fetch",
  APPROVAL_WORKFLOW_DETAIL_FETCH: "approval-workflow-detail-fetch",
};
